import React from "react";

interface MainToolbarContextProps {
    children?: React.ReactNode;
}

export const MainToolbarContext = React.createContext({
    ref: null as React.RefObject<HTMLDivElement>,
});

class MainToolbarContextContainer extends React.Component<MainToolbarContextProps> {
    render() {
        const contextValue = {
            ref: null,
        };

        return (
            <MainToolbarContext.Provider value={contextValue}>
                {this.props.children}
            </MainToolbarContext.Provider>
        );
    }
}

export default MainToolbarContextContainer;
